import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "empty"]
  filter(event) {
    const category = event.currentTarget.dataset.category
    this.element.querySelectorAll(".filter-bar button").forEach((button) => button.classList.toggle("active", button === event.currentTarget))
    let visible = 0
    this.itemTargets.forEach((item) => { item.hidden = category !== "全部" && item.dataset.category !== category; if (!item.hidden) visible += 1 })
    this.emptyTarget.hidden = visible > 0
  }
}
